const {h, render, Component} = require('preact');
const {route} = require('preact-router')
const OrderView = require('../../views/main/order')

class Order extends Component {
  constructor(props) {
    super(props);
    if(this.props.item)
      this.orderId = this.props.item.id
    this.routeToDetails = this.routeToDetails.bind(this);
  }

  routeToDetails() {
    if(this.props.item.isPayToClaim)
      route(`/customer_support/web/claim/summary?claimId=${this.props.item.claimId}`);
    else
      route(`/customer_support/web/order?order_id=${this.orderId}`);
  }

  render(props, state) {
    return (
        <OrderView
            order={props.item}
            orderDetails={this.routeToDetails.bind(this)}
        />
    )
  }
}

module.exports = Order
